import { toast } from "sonner";

const STORAGE_KEY = "suppress_currency_gain_toasts";
let installed = false;
let originalSuccess;

export function setCurrencyGainToastSuppression(enabled) {
  if (enabled) localStorage.setItem(STORAGE_KEY, "true");
  else localStorage.removeItem(STORAGE_KEY);
}

export function currencyGainToastsSuppressed() {
  return localStorage.getItem(STORAGE_KEY) === "true";
}

export function isCurrencyGainToast(message) {
  if (typeof message !== "string") return false;
  const text = message.toLowerCase();
  if (!/\b(gold|follis)\b/.test(text)) return false;
  if (/\b(paid|spent|deducted|donated|placed|for)\b/.test(text)) return false;
  return /\+\s*[\d,]+\s*(gold|follis)|\b(received|awarded|earned|claimed|added|refined|refunded|returned|gained|reward|fortuna|redeemed)\b/.test(text);
}

export function currencyGainToast(message, options) {
  if (currencyGainToastsSuppressed()) return undefined;
  return toast.success(message, options);
}

export function installCurrencyGainToastGate() {
  if (installed) return;
  originalSuccess = toast.success.bind(toast);
  toast.success = (message, ...args) => {
    if (currencyGainToastsSuppressed() && isCurrencyGainToast(message)) return undefined;
    return originalSuccess(message, ...args);
  };
  installed = true;
}